function formatPhone(phone) {
	if (!phone) {
		return '';
	}
	const digits = String(phone).replace(/\D/g, '');
	return digits ? `+${digits}` : '';
}

function appendField(formData, key, value) {
	if (value !== null && value !== undefined && value !== '') {
		formData.append(key, value);
	}
}

function isOtherSchoolId(schoolId) {
	return schoolId === 0 || schoolId === '0';
}

function shouldIncludeSchoolId(requestData) {
	const educationType = Number(requestData.education_type_id);
	return (educationType === 1 || educationType === 2)
		&& Number(requestData.school_country_id) === 398;
}

function appendSchoolFields(formData, requestData = {}) {
	if (!shouldIncludeSchoolId(requestData)) {
		return;
	}

	const selectedValue = requestData.school_region_ab;
	if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
		formData.append('school_region_id', selectedValue);
	}

	if (isOtherSchoolId(requestData.school_id)
		|| requestData.school_id === null
		|| requestData.school_id === undefined) {
		formData.append('school_id', '');
	} else {
		formData.append('school_id', requestData.school_id);
	}
}

export function buildAddOrderFormData(requestData, qualificationSelected, files = {}, options = {}) {
	const formData = new FormData();

	appendField(formData, 'ecp', requestData.p12);
	appendField(formData, 'password', requestData.password);
	appendField(formData, 'payment_type', requestData.payment_type_id);
	appendField(formData, 'training_type', requestData.training_type_id);
	appendField(formData, 'education_form', requestData.education_form_id);
	appendField(formData, 'region_id', requestData.region_ab);
	appendField(formData, 'declarant_type', requestData.declarant_type_id);
	appendField(formData, 'citizen_status', requestData.citizen_status_id);
	appendField(formData, 'nationality_id', requestData.nationality_id);
	appendField(formData, 'abiturient_iin', requestData.iin);
	appendField(formData, 'abiturient_surname', requestData.surname);
	appendField(formData, 'abiturient_name', requestData.name);
	appendField(formData, 'abiturient_lastname', requestData.lastname);
	appendField(formData, 'abiturient_date', requestData.birthday);
	appendField(formData, 'abiturient_email', requestData.email);
	appendField(formData, 'abiturient_phone', formatPhone(requestData.phone_number));
	appendField(formData, 'parent_phone', formatPhone(requestData.parent_phone_number));

	appendField(formData, 'school_country_id', requestData.school_country_id);
	appendSchoolFields(formData, requestData, options);
	appendField(formData, 'graduation_year', requestData.graduation_year);
	appendField(formData, 'education_type', requestData.education_type_id);
	appendField(formData, 'education_document', requestData.education_document_type_id);

	const quotaType = normalizeQuotaType(
		requestData.quota_list && requestData.quota_list[0] && requestData.quota_list[0].id
	);
	formData.append('quota_type', quotaType === null ? '' : quotaType);

	if (files.educationDocumentFile) {
		formData.append('document_file', files.educationDocumentFile);
	}
	if (files.form086File) {
		formData.append('form_086_file', files.form086File);
	}
	if (files.quotaDocumentFile) {
		formData.append('quota_file', files.quotaDocumentFile);
	}

	qualificationSelected.forEach((item, index) => {
		if (!item || !item.qualification_id) {
			return;
		}
		const chosen = requestData.choosed_qualification[index];
		if (!chosen || !chosen.college_id || !chosen.lang) {
			return;
		}
		formData.append(`qualification_ids[${index}][id]`, item.qualification_id);
		formData.append(`qualification_ids[${index}][college]`, chosen.college_id);
		formData.append(`qualification_ids[${index}][lang]`, chosen.lang);
		if (options.includeIsTargetGrant) {
			formData.append(
				`qualification_ids[${index}][is_target_grant]`,
				chosen.target_grant ? 'true' : 'false'
			);
		}
	});

	return formData;
}

const EDIT_SCALAR_FIELDS = [
	['declarant_type_id', 'declarant_type'],
	['citizen_status_id', 'citizen_status'],
	['nationality_id', 'nationality_id'],
	['iin', 'abiturient_iin'],
	['surname', 'abiturient_surname'],
	['name', 'abiturient_name'],
	['lastname', 'abiturient_lastname'],
	['birthday', 'abiturient_date'],
	['email', 'abiturient_email'],
	['phone_number', 'abiturient_phone'],
	['parent_phone_number', 'parent_phone'],
];

const NUMERIC_EDIT_FIELDS = new Set([
	'declarant_type',
	'citizen_status',
	'nationality_id',
]);

function normalizePhoneForCompare(phone) {
	if (!phone) {
		return '';
	}
	return String(phone).replace(/\D/g, '');
}

function normalizeSchoolId(value) {
	if (value === 0 || value === '0' || value === null || value === undefined || value === '') {
		return '';
	}
	return String(value);
}

function normalizeQuotaType(value) {
	if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
		return null;
	}
	return Number(value);
}

function getQuotaTypeId(requestData) {
	return normalizeQuotaType(requestData.quota_list && requestData.quota_list[0] && requestData.quota_list[0].id);
}

function editValuesEqual(apiKey, originalValue, currentValue) {
	if (apiKey === 'abiturient_phone' || apiKey === 'parent_phone') {
		return normalizePhoneForCompare(originalValue) === normalizePhoneForCompare(currentValue);
	}
	if (apiKey === 'school_id') {
		return normalizeSchoolId(originalValue) === normalizeSchoolId(currentValue);
	}
	if (apiKey === 'quota_type') {
		return normalizeQuotaType(originalValue) === normalizeQuotaType(currentValue);
	}
	if (apiKey === 'abiturient_lastname' || apiKey === 'abiturient_email') {
		return String(originalValue || '') === String(currentValue || '');
	}
	if (NUMERIC_EDIT_FIELDS.has(apiKey)) {
		const original = originalValue === null || originalValue === undefined || originalValue === ''
			? null
			: Number(originalValue);
		const current = currentValue === null || currentValue === undefined || currentValue === ''
			? null
			: Number(currentValue);
		return original === current;
	}
	return String(originalValue ?? '') === String(currentValue ?? '');
}

function appendEditScalar(formData, apiKey, value) {
	if (apiKey === 'abiturient_phone' || apiKey === 'parent_phone') {
		formData.append(apiKey, formatPhone(value));
		return;
	}
	if (apiKey === 'school_id') {
		formData.append(apiKey, normalizeSchoolId(value));
		return;
	}
	if (apiKey === 'quota_type') {
		formData.append(apiKey, value === null || value === undefined ? '' : value);
		return;
	}
	formData.append(apiKey, value === null || value === undefined ? '' : value);
}

function normalizeQualificationEntries(choosedList) {
	return (choosedList || [])
		.filter((item) => item && item.qualification_id && item.college_id && item.lang)
		.map((item) => ({
			id: Number(item.qualification_id),
			college: item.college_id,
			lang: item.lang,
		}));
}

function qualificationsEqual(originalEntries, currentEntries) {
	if (originalEntries.length !== currentEntries.length) {
		return false;
	}
	return originalEntries.every((item, index) => {
		const current = currentEntries[index];
		return item.id === current.id
			&& String(item.college) === String(current.college)
			&& String(item.lang) === String(current.lang);
	});
}

function appendQualifications(formData, entries) {
	entries.forEach((item, index) => {
		formData.append(`qualification_ids[${index}][id]`, item.id);
		formData.append(`qualification_ids[${index}][college]`, item.college);
		formData.append(`qualification_ids[${index}][lang]`, item.lang);
	});
}

export function buildEditOrderFormData(orderId, original, current, files = {}) {
	const formData = new FormData();
	formData.append('id', orderId);
	formData.append('abiturient', original.iin ?? '');

	let hasChanges = false;

	EDIT_SCALAR_FIELDS.forEach(([dataKey, apiKey]) => {
		const originalValue = original[dataKey];
		const currentValue = current[dataKey];
		if (!editValuesEqual(apiKey, originalValue, currentValue)) {
			appendEditScalar(formData, apiKey, currentValue);
			hasChanges = true;
		}
	});

	const originalQuota = getQuotaTypeId(original);
	const currentQuota = getQuotaTypeId(current);
	if (!editValuesEqual('quota_type', originalQuota, currentQuota)) {
		appendEditScalar(formData, 'quota_type', currentQuota);
		hasChanges = true;
	}

	if (files.educationDocumentFile) {
		formData.append('document_file', files.educationDocumentFile);
		hasChanges = true;
	}
	if (files.form086File) {
		formData.append('form_086_file', files.form086File);
		hasChanges = true;
	}
	if (files.quotaDocumentFile) {
		formData.append('quota_file', files.quotaDocumentFile);
		hasChanges = true;
	}

	const originalQualifications = normalizeQualificationEntries(original.choosed_qualification);
	const currentQualifications = normalizeQualificationEntries(current.choosed_qualification);
	if (!qualificationsEqual(originalQualifications, currentQualifications)) {
		appendQualifications(formData, currentQualifications);
		hasChanges = true;
	}

	return { formData, hasChanges };
}

const BIRTHDAY_MIN_YEAR = 1901;

export function formatMaxBirthdayDate(date = new Date()) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export function validateBirthdayDate(value, t) {
	if (!value || !String(value).trim()) {
		return t('Обязательное поле');
	}

	const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (!match) {
		return t('Неправильный формат');
	}

	const year = Number(match[1]);
	const month = Number(match[2]);
	const day = Number(match[3]);

	if (year < BIRTHDAY_MIN_YEAR) {
		return t('Год не может быть меньше 1901');
	}

	const birthDate = new Date(year, month - 1, day);
	if (
		birthDate.getFullYear() !== year
		|| birthDate.getMonth() !== month - 1
		|| birthDate.getDate() !== day
	) {
		return t('Неправильный формат');
	}

	const today = new Date();
	today.setHours(0, 0, 0, 0);
	if (birthDate > today) {
		return t('Дата не может быть позже текущей');
	}

	return true;
}

export function createBirthdayDateRules(t) {
	return [
		(v) => {
			const result = validateBirthdayDate(v, t);
			return result === true ? true : result;
		},
	];
}
